import { SUBSCRIPTION } from 'constants/checkoutCollectionGroupTypes';

export function transformBundleOption(optionList, t) {
  return optionList.map(
    ({
      requiredOptionsCount,
      displayPrice: { discount: optionDiscount, sellingPrice },
      plan: { planType },
    }) => ({
      count: requiredOptionsCount,
      hasDiscount: optionDiscount,
      percentage: optionDiscount?.percentage || 0,
      percentageZH: optionDiscount?.rate,
      price:
        planType === SUBSCRIPTION
          ? `${sellingPrice}${t('purchase.content.subscriptions.priceUnit')}`
          : sellingPrice,
    }),
  );
}

export function getPlanCardBundleDescription(optionList, t) {
  const MAX_DISPLAY_OPTION_AMOUNT = 2;

  const optionWithDiscountList = transformBundleOption(optionList, t);

  const displayEveryOption = optionList.length <= MAX_DISPLAY_OPTION_AMOUNT;

  if (displayEveryOption)
    return optionWithDiscountList
      .map(option =>
        option.hasDiscount
          ? t(
              'purchase:purchase.content.promoDealsBundle.itemWithDiscount',
              option,
            )
          : t(
              'purchase:purchase.content.promoDealsBundle.itemNoDiscount',
              option,
            ),
      )
      .join(' / ');

  const firstCount = optionWithDiscountList[0].count;
  const lastCount =
    optionWithDiscountList[optionWithDiscountList.length - 1].count;

  const optionDiscountList = optionWithDiscountList.map(
    ({ percentage }) => percentage,
  );

  const highestDiscount = Math.max(...optionDiscountList);
  const highestDiscountOption = optionWithDiscountList.find(
    option => option.percentage === highestDiscount,
  );

  return highestDiscount
    ? t('purchase.content.promoDealsBundle.itemRangeWithDiscount', {
        mincount: firstCount,
        maxcount: lastCount,
        ...highestDiscountOption,
      })
    : t('purchase.content.promoDealsBundle.itemRangeNoDiscount', {
        mincount: firstCount,
        maxcount: lastCount,
      });
}

export function getBundlePageBundleDescription(optionList, t) {
  const optionWithDiscountList = transformBundleOption(optionList, t);

  return optionWithDiscountList.map((option, index) =>
    option.hasDiscount
      ? {
          option: t(
            'purchase:purchase.content.promoDealsBundle.descriptionWithDiscount',
            option,
          ),
          key: index,
        }
      : {
          option: t(
            'purchase:purchase.content.promoDealsBundle.descriptionNoDiscount',
            option,
          ),
          key: index,
        },
  );
}
